import actionTypes from '../../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_SORTING_FUNCTION:
      return action.sortingFunction;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/utils/reducers/sorting-function/sorting-function.js